import { Outlet, useParams } from "react-router";
import { AlertBanner, Contacts } from '../../sitel/demon/ui/atoms';
import { titleText } from "../../components/utils/medstarAssociationTexts";
import { ErrorPage } from "../../components/error";

export default function Layout() {
    const { medstarAssociationType } = useParams();
    const language = titleText(medstarAssociationType);
    const AllGood = () => {
        return (
            <>
                <AlertBanner>
                    If you experience any issues creating your account online, <Contacts.SitelHelpDeskLanguage />.
                </AlertBanner>
                <Outlet context={{ language }} />
            </>
        );
    }

    const ErrorOccured = () => {
        console.error('Issue in routes/new/layout.jsx');
        return <ErrorPage />;
    }

    return (
        <>
            {(medstarAssociationType && language && AllGood()) || ErrorOccured()}
        </>
    );
}

